import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiGetInternalEnrichmentRequests = (funcToDispatch, error, callback) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/enrichmentManager",
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiGetInternalEnrichmentRequests"),
  })
}

export const apiCloseEnrichmentRequest = (params, funcToDispatch, error, callback) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/enrichmentManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiCloseEnrichmentRequest"),
  })
}

export const apiCreateSandbox = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/createSandboxManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    success,
    error: wrapError(error, "apiCreateSandbox"),
  })
}

export const apiDeleteAllConstituents = (success, error) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/deleteConstituentsManager",
    dataType: "JSON",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: "{}",
    success,
    error: wrapError(error, "apiDeleteAllConstituents"),
  })
}

export const apiUpdateTotalMembers = (success, error) => {
  $.ajax({
    type: "PUT",
    url: "/api/internal/totalMembersManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({}),
    success,
    error: wrapError(error, "apiCloseEnrichmentRequest"),
  })
}

export const apiUploadConstituentData = (params, funcToDispatch, error, callback) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/dataUploadManager",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiUploadConstituentData"),
  })
}

export const apiGetImportsHistory = (funcToDispatch, error, callback) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/dataUploadHistory",
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiGetImportsHistory"),
  })
}
